var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consolidate"},[_c('slider',{ref:"consolidate_slider",attrs:{"options":_vm.consolidateData},on:{"slide":_vm.consolidateslide}},_vm._l((_vm.consolidateList),function(item,index){return _c('slideritem',{key:index,staticStyle:{"color":"red"}},[_c('CourseList',{attrs:{"item":item}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }